export enum FlightRequestStatus {
  REQUESTED = 0,
  CANCELED = -3,
  FLIGHT_BOOKED = 12,
  HOLD_ERROR = 99,
  PAYMENT_ERROR = -1,
}
